import { TrackEvent } from '@bnnvara/analytics';
import React from 'react';

import * as S from '../styled';

const MenuButton = () => (
  <>
    <S.HomeButton
      type="link"
      href="/"
      variant="text"
      onClick={TrackEvent('bnnvara-menu', 'click', 'home')}
    >
      Home
    </S.HomeButton>
    <S.HomeButton
      type="link"
      href="/catalogus/programmas"
      variant="text"
      onClick={TrackEvent('bnnvara-menu', 'click', 'titels')}
    >
      Titels
    </S.HomeButton>
  </>
);

export default MenuButton;
